<template>
	<div class="moonSampleSearchClass">
		<div class="moonContent" v-if="!inforFlag && !editInforFlag">
			<span class="moonClass" v-if="borrwingFlag">可借用样品数据展示</span>
			<div class="searchDivClass">
				<div class="titleNameClass">
					<div style="display: flex">
						<span class="lineClass"></span>
						<span class="sampleTypeClass">样品类型</span>
					</div>

					<div class="inforNameClass">
						<div class="spanDivClass" v-for="(item, index) in inforArr" :key="index">
							<span class="nameClass" v-if="item && item[0]">{{ item[0].level }}</span>
							<span
								:class="activeItem.includes(itemChild.name) ? 'typeClass1' : 'typeClass2'"
								v-for="(itemChild, indexC) in item"
								:key="indexC"
								@click="changeSampleType(itemChild, indexC)"
								>{{ itemChild.name }}</span
							>
						</div>
					</div>
				</div>
				<div class="sampleEditClass">
					<div class="sampleNum">
						<div class="sampleNumTitleClass">
							<span class="lineClass"></span>
							<span class="sampleNumClass">样品编号</span>
						</div>

						<el-input v-model="sampleObj.code" placeholder="样品编号" clearable></el-input>
					</div>
					<div class="sampleNum">
						<div class="sampleNumTitleClass">
							<span class="lineClass"></span>
							<span class="sampleNumClass">样品原始重量</span>
						</div>
						<div class="weightClass" style="display: flex; align-items: baseline">
							<el-input style="width: 100px" v-model="sampleObj.currentWeightMin" clearable></el-input>g
							<span style="margin: 4px"> - </span>
							<el-input style="width: 100px" v-model="sampleObj.currentWeightMax" clearable></el-input>g
						</div>
					</div>
				</div>
				<div class="sampleEditClass">
					<div class="sampleNum">
						<div class="sampleNumTitleClass">
							<span class="lineClass"></span>
							<span class="sampleNumClass">样品特征</span>
						</div>
						<el-input v-model="sampleObj.sampleType" placeholder="样品特征" clearable></el-input>
					</div>
					<div class="sampleNum">
						<div class="sampleNumTitleClass">
							<span class="lineClass"></span>
							<span class="sampleNumClass">使用状态</span>
						</div>
						<div style="display: flex; justify-content: space-between; align-items: baseline">
							<el-select style="width: 130px" v-model="sampleObj.statusList" clearable placeholder="请选择">
								<el-option v-for="item in options" :key="item.value" :label="item.label" :value="item.value"> </el-option>
							</el-select>
							<el-button class="btnClass" size="small" icon="el-icon-search" @click="searchSampleFunc()"> 确定</el-button>
						</div>
					</div>
				</div>
			</div>
			<div class="tableDataClass">
				<div style="display: flex; justify-content: space-between">
					<div style="text-align: left">查询结果：共{{ totalMoonSample }}条</div>
					<el-button type="primary" style="background-color: #15418c" size="mini" @click="batchBorrowFunc()">批量借用</el-button>
				</div>

				<el-table ref="multipleTable" :data="moonSampleTableData" :row-key="(row) => row.id" @selection-change="handleSelectionChange" stripe :height="500">
					<el-table-column type="selection" :reserve-selection="true" width="55"> </el-table-column>
					<el-table-column type="index" width="50" align="center"></el-table-column>
					<el-table-column label="样品编号" width="220">
						<template slot-scope="scope">
							<div :title="scope.row.code" style="white-space: nowrap; overflow: hidden; text-overflow: ellipsis">
								{{ scope.row.code }}
							</div>
						</template>
					</el-table-column>
					<el-table-column label="样品类型" width="200">
						<template slot-scope="scope">
							{{ scope.row.sampleCategory1 != null ? scope.row.sampleCategory1 : '' }}
							{{ scope.row.sampleCategory2 != null ? '/' + scope.row.sampleCategory2 : '' }}
							{{ scope.row.sampleCategory3 != null ? '/' + scope.row.sampleCategory3 : '' }} {{ scope.row.sampleCategory4 != null ? '/' + scope.row.sampleCategory4 : '' }}
						</template>
					</el-table-column>

					<el-table-column prop="sampleType" label="样品特征">
						<template slot-scope="scope">
							<span v-html="scope.row.sampleType" style="font-size: unset"></span>
						</template>
					</el-table-column>
					<el-table-column prop="num" label="数量(个)" align="center">-- </el-table-column>
					<el-table-column prop="availableWeight" label="重量(mg)" align="center"> </el-table-column>
					<el-table-column prop="lidu" label="样品粒度(毫米)" :width="120" align="center"> --</el-table-column>
					<el-table-column label="样本照片">
						<template slot-scope="scope">
							<img v-if="scope.row.images && scope.row.images.length > 0" :src="scope.row.images[0].thumbnail.split(',')[0]" style="width: 44px; height: 44px" />
							<span v-else> -- </span>
						</template>
					</el-table-column>
					<el-table-column label="使用状态">
						<template slot-scope="scope">
							<span v-if="scope.row.status == 0">不可申请</span>
							<span v-else-if="scope.row.status == 1">可申请</span>
							<span v-else-if="scope.row.status == 2">待取样</span>
							<span v-else-if="scope.row.status == 3">借用中</span>
							<span v-else-if="scope.row.status == 5">返还监测中</span>
							<span v-else>借用审核中</span>
						</template>
					</el-table-column>
					<el-table-column label="操作">
						<template slot-scope="scope">
							<el-button @click="handleInforClick(scope.row)" type="text" size="small">详情</el-button>
							<!-- <el-button type="text" size="small" @click="borrowSampleFunc(scope.row)">借用</el-button> -->
						</template>
					</el-table-column>
				</el-table>
				<div class="block" style="background-color: #fff; height: 50px; display: flex; justify-content: end; align-items: center">
					<el-pagination
						@size-change="handleSizeChange"
						@current-change="handleCurrentChange"
						:current-page="currentPage"
						:page-sizes="[10, 20, 50, 100]"
						:page-size="pageSize"
						background
						layout="total, sizes, prev, pager, next, jumper"
						:total="totalMoonSample"
					>
					</el-pagination>
				</div>
			</div>
		</div>

		<!-- 添加或修改月球样品借用返还对话框 -->
		<el-dialog title="月球样品借用申请信息" :visible.sync="openDialog" :close-on-click-modal="false" style="z-index: 20009" :close-on-press-escape="false" width="90%">
			<borrowSampleInfoBatch ref="batchBorrowinit"></borrowSampleInfoBatch>
			<!-- <addSampleInfoVue v-else ref="addFormInit"></addSampleInfoVue> -->
			<mySampleBorrowingVue ref="addMySampleBorrow"></mySampleBorrowingVue>

			<template #footer>
				<div class="dialog-footer">
					<el-button type="primary" @click="submitForm">提 交</el-button>
				</div>
			</template>
		</el-dialog>

		<sampleInfor v-if="inforFlag" ref="sampleInfoRef" @goBackFunc="goBackFunc"></sampleInfor>
		<editMoonSampleInfor v-if="editInforFlag" ref="editSampleRef" @goBackFunc="goBackFunc"></editMoonSampleInfor>
	</div>
</template>

<script>
import sampleInfor from '../sampleSearch/moonSampleInfor.vue'
import editMoonSampleInfor from '../sampleSearch/editMoonSampleInfor.vue'
import cookie from '../../../../utils/cookie'
import addSampleInfoVue from './addSampleInfo.vue'
import mySampleBorrowingVue from '../mySampleBorrowing.vue'
import borrowSampleInfoBatch from './borrowSampleInfoBatch.vue'
export default {
	name: 'moonSampleIndex',
	props: {},
	components: {
		sampleInfor,
		editMoonSampleInfor,
		addSampleInfoVue,
		mySampleBorrowingVue,
		borrowSampleInfoBatch
	},
	data() {
		return {
			batchFlag: false,
			multipleSelection: [],
			borrowingObj: false,
			options: [
				{
					value: '1',
					label: '可申请'
				},
				{
					value: '2',
					label: '待取样'
				},
				// {
				// 	value: '3',
				// 	label: '借用中'
				// },
				{
					value: '4',
					label: '借用审核中'
				},
				{
					value: '5',
					label: '返还监测中'
				}
			],
			openDialog: false,
			addBorrowForm: {},
			totalCount: {},
			borrwingFlag: true,
			activeItem: [],
			activeLevel: [],
			activeItemObj: [],
			sampleObj: {
				code: '',
				sampleType: '',
				statusList: [],
				currentWeight: '',
				currentWeightMin: '',
				currentWeightMax: ''
			},
			inforFlag: false,
			editInforFlag: false,
			moonSampleTableData: [],
			sampleNum: '',
			inforArr: [[{ level: '一级', itemChild: [] }]],
			currentPage: 1,
			pageSize: 10,
			totalMoonSample: 0
		}
	},
	mounted() {
		this.getMoonSampleListFunc()
		this.initFunc()
		this.getMoonSampleStatusCount()
	},
	methods: {
		handleSelectionChange(val) {
			this.multipleSelection = val
		},
		async submitForm() {
			this.addBorrowForm = this.$refs.batchBorrowinit.submitFunc()
			this.borrowingObj = this.$refs.addMySampleBorrow.submitSampleFunc()
			if (!this.addBorrowForm || !this.borrowingObj) {
				return
			}
			let newForm = {
				...this.addBorrowForm,
				action: 'UserBorrow',
				sampleOrderBorrow: {
					...this.borrowingObj
				}
			}
			console.log(newForm)
			let res = await this.$http.post(this.$const.moonSample.addMoonSampleBorrowingReturn, newForm)
			if (res && res.code == 200) {
				this.openDialog = false
				this.initFunc()
				this.$message.success('生成订单成功！')
			}
		},
		batchBorrowFunc(item) {
			if (!this.$store.state.user.isLogin || !this.$cookie.get('userCreateBy')) {
				alert('请登录用户！')
				return
			}
			if (this.multipleSelection.length == 0) {
				alert('请选择数据！')
				return
			}
			this.openDialog = true
			this.$nextTick(() => {
				let newBorrowData = []
				this.multipleSelection.forEach((element) => {
					newBorrowData.push({
						orderNo: element.code,
						code: element.code,
						id: element.id,
						sampleDataId: element.sampleDataId,
						useType: element.useType,
						currentWeight: element.currentWeight,
						borrowWeight: element.currentWeight,
						availableWeight: element.currentWeight,
						sampleCategory3: element.sampleCategory3,
						useStartTime: element.useStartTime,
						useEndTime: element.useEndTime,
						expectedConsumption: element.expectedConsumption
					})
				})
				this.addBorrowForm = this.$refs.batchBorrowinit.initForm(newBorrowData)
			})
		},
		borrowSampleFunc(item) {
			if (!this.$store.state.user.isLogin || !this.$cookie.get('userCreateBy')) {
				alert('请登录用户！')
				return
			}
			this.multipleSelection = []
			this.$refs.multipleTable.clearSelection()
			this.openDialog = true
			this.$nextTick(() => {
				let newBorrowData = []
				newBorrowData.push({
					orderNo: item.code,
					code: item.code,
					id: item.id,
					sampleDataId: item.sampleDataId,
					useType: item.useType,
					currentWeight: item.currentWeight,
					borrowWeight: item.currentWeight,
					availableWeight: item.currentWeight,
					sampleCategory3: item.sampleCategory3,
					useStartTime: item.useStartTime,
					useEndTime: item.useEndTime,
					expectedConsumption: item.expectedConsumption
				})
				this.addBorrowForm = this.$refs.batchBorrowinit.initForm(newBorrowData)
				// this.addBorrowForm = this.$refs.addFormInit.initForm(item)
				// this.addBorrowForm.createBy = this.$cookie.get('userCreateBy')
				// if (this.addBorrowForm) {
				// 	let formObj = this.addBorrowForm
				// 	formObj.id = this.addBorrowForm.sampleDataId
				// 	formObj.code = this.addBorrowForm.orderNo
				// 	this.addBorrowForm = this.$refs.addFormInit.initForm(formObj)
				// }
				// this.$refs.addMySampleBorrow.borrowInit(this.addBorrowForm)
			})
		},
		handleCurrentChange(val) {
			this.currentPage = val
			this.initFunc()
		},
		handleSizeChange(val) {
			this.pageSize = val
			this.initFunc()
		},
		changeSampleType(itemObj) {
			if (this.activeLevel.includes(itemObj.level) && this.activeItem.includes(itemObj.name)) {
				this.activeItem.forEach((element, index) => {
					if (element == itemObj.name) {
						this.activeItem.splice(index, 1)
						this.activeItemObj.splice(index, 1)
						this.activeLevel.splice(index, 1)
					}
				})
			} else {
				if (this.activeLevel.includes(itemObj.level)) {
					this.activeItemObj.forEach((element, indexObj) => {
						if (element.level == itemObj.level) {
							this.activeItem.splice(indexObj, 1)
							this.activeItemObj.splice(indexObj, 1)
							this.activeLevel.splice(indexObj, 1)
						}
					})
				}
				this.activeItem.push(itemObj.name)
				this.activeItemObj.push(itemObj)
				this.activeLevel.push(itemObj.level)
			}
			console.log(this.activeItemObj)
		},
		searchSampleFunc() {
			this.initFunc()
		},
		async getMoonSampleListFunc() {
			this.inforArr[0] = []
			this.inforArr[1] = []
			this.inforArr[2] = []
			this.inforArr[3] = []
			let res = await this.$http.get(this.$const.moonSample.getMoonSampleTypeList + `?pageNum=1&pageSize=100`)
			if (res && res.code == 200) {
				const resultData = res.data
				resultData.forEach((element) => {
					if (element.level == '一级') {
						this.inforArr[0].push(element)
					} else if (element.level == '二级') {
						this.inforArr[1].push(element)
					} else if (element.level == '三级') {
						this.inforArr[2].push(element)
					} else if (element.level == '四级') {
						this.inforArr[3].push(element)
					}
				})
			}
		},
		async initFunc() {
			let sampleCategory1 = '',
				sampleCategory2 = '',
				sampleCategory3 = '',
				sampleCategory4 = ''

			if (this.activeItemObj && this.activeItemObj.length > 0) {
				this.activeItemObj.forEach((element) => {
					if (element.level == '一级') {
						sampleCategory1 += element.code + ','
					} else if (element.level == '二级') {
						sampleCategory2 += element.code + ','
					} else if (element.level == '三级') {
						sampleCategory3 += element.code + ','
					} else if (element.level == '四级') {
						sampleCategory4 += element.code + ','
					}
				})
				const reg = /,$/gi
				sampleCategory1 = sampleCategory1.replace(reg, '')
				sampleCategory2 = sampleCategory2.replace(reg, '')
				sampleCategory3 = sampleCategory3.replace(reg, '')
				sampleCategory4 = sampleCategory4.replace(reg, '')
			}
			const params = {
				pageNum: this.currentPage,
				pageSize: this.pageSize,
				statusList: this.sampleObj.statusList.length > 0 ? this.sampleObj.statusList.toString() : `1`
			}
			if (sampleCategory1 !== '') params.sampleCategory1 = sampleCategory1
			if (sampleCategory2 !== '') params.sampleCategory2 = sampleCategory2
			if (sampleCategory3 !== '') params.sampleCategory3 = sampleCategory3
			if (sampleCategory4 !== '') params.sampleCategory4 = sampleCategory4
			if (this.sampleObj.code !== '') params.code = this.sampleObj.code
			if (this.sampleObj.sampleType !== '') params.sampleType = this.sampleObj.sampleType
			if (this.sampleObj.status !== '') params.status = this.sampleObj.status
			if (this.sampleObj.currentWeightMin !== '') params.currentWeightMin = this.sampleObj.currentWeightMin
			if (this.sampleObj.statusList !== '') params.statusList = this.sampleObj.statusList
			if (this.sampleObj.currentWeightMax !== '') params.currentWeightMax = this.sampleObj.currentWeightMax

			let res = await this.$http.get(this.$const.moonSample.getMoonSampleList, params)
			if (res && res.code == 200) {
				this.moonSampleTableData = res.rows
				this.totalMoonSample = res.total
			}
		},
		async getMoonSampleStatusCount() {
			let res = await this.$http.get(this.$const.moonSample.getMoonSampleStatusCount)
			if (res && res.code == 200) {
				this.totalCount = res.data
			}
		},
		async handleInforClick(row) {
			// this.inforFlag = true
			await this.$http.get(this.$const.moonSample.viewsInfo + `/${row.id}`)
			this.$nextTick(() => {
				// this.$refs.sampleInfoRef.initDataFunc(row)
				window.open(this.$router.resolve({ path: `/moonSampleInfor`, query: { obj: JSON.stringify(row) } }).href, '_blank')
				// this.$router.push({ path: '/moonSampleInfor', query: { obj: row } }) // 传递查询参数q=vue
			})
		},
		editSample(row) {
			console.log(row)
			this.editInforFlag = true
			this.$nextTick(() => {
				this.$refs.editSampleRef.initDataFunc(row)
			})
		},
		goBackFunc(type) {
			if (type == 1) {
				this.inforFlag = false
			} else {
				this.editInforFlag = false
			}
		}
	}
}
</script>

<style lang="scss" scoped>
.moonSampleSearchClass {
	width: 100%;
	// height: 1510px;
	text-align: center;
	background: #f0f5ff;
	margin-bottom: 20px;
	.moonContent {
		width: 1200px;
		text-align: center;
		display: inline-block;
		.moonClass {
			font-size: 28px;
			color: #000000;
			display: block;
			text-align: left;
			// margin-top: 30px;
			margin-bottom: 10px;
		}
		.searchDivClass {
			display: flex;
			// height: 246px;
			background: #ffffff;
			border-radius: 4px;
			border: 1px solid rgba(21, 65, 140, 0.2);
			margin-bottom: 22px;
			padding: 10px;
			height: 280px;
			justify-content: space-around;
			.titleNameClass {
				// display: flex;
				display: block;
				justify-content: left;
				align-items: center;
				height: 30px;
				padding: 5px;
				.lineClass {
					width: 2px;
					height: 16px;
					background: #15418c;
				}
				.sampleTypeClass {
					height: 21px;
					font-family: MicrosoftYaHeiUISemibold;
					font-size: 16px;
					color: #000000;
					line-height: 21px;
					text-align: left;
					font-style: normal;
					display: block;
					margin-left: 8px;
				}
			}

			.sampleEditClass {
				display: flex;
				// justify-content: space-around;
				align-items: baseline;
				margin-top: 10px;
				flex-direction: column;
				padding-right: 20px;
				.sampleNum {
					// width: 280px;
					padding: 6px;
					.sampleNumTitleClass {
						display: flex;
						align-items: center;
						margin-bottom: 8px;
						.lineClass {
							width: 2px;
							height: 16px;
							background: #15418c;
						}
						.sampleNumClass {
							height: 21px;
							font-family: MicrosoftYaHeiUISemibold;
							font-size: 16px;
							color: #000000;
							line-height: 21px;
							text-align: left;
							font-style: normal;
							display: block;
							margin-left: 8px;
						}
					}
				}
			}
			.inforNameClass {
				display: flex;
				justify-content: left;
				align-items: baseline;
				flex-wrap: wrap;
				flex-direction: column;
				.spanDivClass {
					display: flex;
					justify-content: stretch;
					-webkit-box-align: baseline;
					align-items: center;
					padding: 8px;
					// width: 50%;
					height: 60px;
				}
				.nameClass {
					width: 50px;
					margin-right: 10px;
					height: 40px;
					font-family: MicrosoftYaHeiUI;
					font-size: 16px;
					color: #000000;
					line-height: 21px;
					text-align: left;
					font-style: normal;
					display: flex;
					justify-content: center;
					align-items: center;
				}
				.typeClass2:hover,
				.typeClass1 {
					// width: 116px;
					min-width: 120px;
					max-width: max-content;
					margin-right: 5px;
					height: 40px;
					background: #15418c;
					border-radius: 4px;
					color: #ffffff;
					display: flex;
					justify-content: center;
					align-items: center;
				}
				.typeClass2 {
					// width: 116px;
					height: 40px;
					min-width: 120px;
					max-width: max-content;
					margin-right: 5px;
					background: radial-gradient(396% 161% at 50% 0%, rgba(21, 65, 140, 0.3) 0%, rgba(21, 65, 140, 0) 100%);
					border-radius: 4px;
					display: flex;
					justify-content: center;
					align-items: center;
					cursor: pointer;
				}
			}
			.btnClass {
				background: #15418c;
				border-radius: 4px;

				font-family: MicrosoftYaHeiUI;
				font-size: 16px;
				color: #ffffff;
				line-height: 21px;
				text-align: left;
				font-style: normal;
				line-height: 10px;
				text-align: left;
				font-style: normal;
				margin-top: 5px;
			}
		}
	}
}
</style>
<style>
/* .el-table th.el-table__cell.is-leaf {
	background-color: #15418c;
	color: #ffffff;
}
.el-table tr {
	background: #f0f5ff;
}
.el-table--enable-row-transition .el-table__body td.el-table__cell {
	color: #333333;
	font-size: 14px;
} */
.sampleNum .el-input__inner {
	/* width: 280px; */
	height: 36px;
	background: #ffffff;
	border-radius: 4px;
	border: 1px solid #cccccc;
}
.moonSampleSearchClass .el-dialog__header {
	text-align: left;
	background-color: #fdfdfd;
}
.sampleNum .weightClass .el-input__inner {
	width: 100%;
}
</style>